import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../GlobalComp/PageLayout/PageLayout';
import Classes from '../../GlobalComp/PageLayout/PageLayout.module.css';
import Seo from '../../GlobalComp/Seo/Seo';
import { SERVICES } from '../../../data/services';

// Unknown URLs used to render Home (a "soft 404"); this page is noindex instead.
export default function NotFound() {
    return (
        <>
            <Seo title="Page Not Found | 561-FIX-HOME" description="The page you are looking for could not be found." noindex />
            <PageLayout title="Page Not Found" subtitle="Sorry, we couldn’t find that page. Try one of these instead.">
                <section>
                    <div className={Classes.pills}>
                        <Link to="/">Home</Link>
                        {SERVICES.map((s) => <Link key={s.slug} to={`/services/${s.slug}`}>{s.name}</Link>)}
                        <Link to="/#service-areas">Service Areas</Link>
                        <Link to="/contact-us">Contact Us</Link>
                    </div>
                </section>
            </PageLayout>
        </>
    );
}
